import React from "react";
import { MenuItem } from "@chakra-ui/react";
import { getUserTimezone, setErrorsFromResponse } from "duck";
import { usePrintReferralRecordMutation } from "requests";

interface ReferralRecordProps {
  caseId: number;
  handleClose(): void;
}

const ReferralRecord: React.FC<ReferralRecordProps> = ({
  caseId,
  handleClose
}) => {
  const [exportRecord] = usePrintReferralRecordMutation({
    variables: {
      input: { medicalCase: caseId, userTimezone: getUserTimezone() }
    }
  });

  const handleClick = () => {
    const windowRef = window.open();
    exportRecord()
      .then(result => {
        const fileId =
          result.data?.createReferralDocumentPrint?.referralDocumentPrint?.file
            ?._id;
        if (windowRef && fileId) {
          windowRef.location = `${process.env.REACT_APP_UPLOAD_URL}/files/${fileId}/show`;
        }
      })
      .catch(error => {
        if (windowRef) {
          windowRef.close();
        }
        setErrorsFromResponse(error);
      })
      .finally(handleClose);
  };

  return (
    <MenuItem onClick={handleClick} fontSize="sm">
      Referral record
    </MenuItem>
  );
};

export default ReferralRecord;
